import React from 'react';
import { AuditFilters } from '../types';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Button } from '../../../components/ui/Button';

interface FilterSidebarProps {
  filters: AuditFilters;
  onFiltersChange: (filters: AuditFilters) => void;
  onClearFilters: () => void;
}

export const FilterSidebar: React.FC<FilterSidebarProps> = ({
  filters,
  onFiltersChange,
  onClearFilters
}) => {
  const actionTypes = [
    { value: 'ALL', label: 'All Actions' },
    { value: 'QUOTE_CREATED', label: 'Quote Created' },
    { value: 'QUOTE_EDITED', label: 'Quote Edited' },
    { value: 'QUOTE_APPROVED', label: 'Quote Approved' },
    { value: 'QUOTE_REJECTED', label: 'Quote Rejected' },
    { value: 'QUOTE_CANCELLED', label: 'Quote Cancelled' },
    { value: 'EMAIL_SENT', label: 'Email Sent' }
  ];

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-medium text-gray-900">Filters</h3>
        <Button
          onClick={onClearFilters}
          variant="secondary"
          size="sm"
        >
          Clear All
        </Button>
      </div>

      <div className="space-y-4">
        {/* Date Range Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Start Date
          </label>
          <Input
            type="date"
            value={filters.startDate || ''}
            onChange={(e) => onFiltersChange({ ...filters, startDate: e.target.value })}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            End Date
          </label>
          <Input
            type="date"
            value={filters.endDate || ''}
            onChange={(e) => onFiltersChange({ ...filters, endDate: e.target.value })}
          />
        </div>

        {/* Action Type Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Action Type
          </label>
          <Select
            value={filters.actionType || 'ALL'}
            onChange={(e) => onFiltersChange({ ...filters, actionType: e.target.value })}
          >
            {actionTypes.map((type) => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </Select>
        </div>

        {/* Quote Reference Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Quote Reference
          </label>
          <Input
            type="text"
            placeholder="e.g., Q-2025-1"
            value={filters.quoteReference || ''}
            onChange={(e) => onFiltersChange({ ...filters, quoteReference: e.target.value })}
          />
        </div>

        {/* Search Query */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Search
          </label>
          <Input
            type="text"
            placeholder="Search user, customer, notes..."
            value={filters.searchQuery || ''}
            onChange={(e) => onFiltersChange({ ...filters, searchQuery: e.target.value })}
          />
        </div>
      </div>
    </div>
  );
};